import { get, includes } from 'lodash';
import { ITask, TASK_STATUS } from '@shared/types';
import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';

interface IProgressBarParams {
  messageTemplate?: string;
  task?: ITask;
  currentStep?: number;
  stepCount?: number;

  i18nService: XVII18nService;
}

const generateProgressBarLoadingParams = (options: IProgressBarParams): {} => {
  const { i18nService } = options;

  const task = get(options, 'task');
  const messageTemplate = get(
    options,
    'messageTemplate',
    I18n.InfoMessages.ProgressCurrentProcessedSuccessfully,
  );
  let currentStep = get(options, 'currentStep', 1);
  let stepCount = get(options, 'stepCount', 1);

  // Handle exception parameter
  if (currentStep < 1) currentStep = 1;
  if (stepCount < 1) stepCount = 1;
  if (currentStep > stepCount) currentStep = stepCount;

  const radioGroup = 1 / stepCount;
  const baseCurrent = Math.floor(radioGroup * 100) * (currentStep - 1);
  const subTasks = get(task, 'sub_tasks', []);

  const taskTotal = subTasks.length || 1;
  const taskCurrent = subTasks.filter((t) =>
    includes([TASK_STATUS.failed, TASK_STATUS.completed], t.status),
  ).length;
  const progressTotal = 100;
  let progressCurrent =
    baseCurrent + Math.floor((taskCurrent / taskTotal) * radioGroup * 100);

  if (
    progressCurrent > progressTotal ||
    (currentStep === stepCount && taskTotal === taskCurrent)
  ) {
    progressCurrent = progressTotal;
  }

  const text = i18nService.translate(messageTemplate, {
    taskCurrent,
    taskTotal,
    progressCurrent,
    progressTotal,
  });

  return {
    text,
    showBar: true,
    current: progressCurrent,
    total: progressTotal,
  };
};

export { generateProgressBarLoadingParams, IProgressBarParams };
